"use strict";
exports.__esModule = true;
var inRange = function (n, a, b) {
    return n >= a && n <= b;
};
exports.toMinutes = function (time) {
    var _a = time.split(':').map(Number), hours = _a[0], minutes = _a[1];
    return hours * 60 + minutes;
};
exports.isValidTime = function (time) {
    var _a = time.split(':'), hours = _a[0], minutes = _a[1];
    if (!hours || !minutes) {
        return false;
    }
    if (hours.length !== 2 || minutes.length !== 2) {
        return false;
    }
    if (!inRange(Number(minutes), 0, 59)) {
        return false;
    }
    if (!inRange(Number(hours), 0, 23)) {
        return false;
    }
    return true;
};
exports.defaultDayOpeningHours = {
    from: '10:00',
    to: '18:00'
};
exports.defaultOpeningHours = {
    Monday: exports.defaultDayOpeningHours,
    Tuesday: exports.defaultDayOpeningHours,
    Wednesday: exports.defaultDayOpeningHours,
    Thursday: exports.defaultDayOpeningHours,
    Friday: exports.defaultDayOpeningHours,
    Saturday: null,
    Sunday: null
};
